import script from "./BedbugPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BedbugPage.vue?vue&type=script&setup=true&lang=js"

import "./BedbugPage.vue?vue&type=style&index=0&id=7f5b3713&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5b3713"]])

export default __exports__